







































import { Component, Prop, Emit, Vue, Watch } from 'vue-property-decorator'
const routerMap: object = {
	home: '0',
	restaurantOrders: '1-0',
	restaurantOrdersDetails: '1-0',
	restaurantReturns: '1-1',
	restaurantReturnDetails: '1-1',
	restaurantQuotations: '1-2',
	restaurantQuotationDetails: '1-2',
	restaurantAccount: '1-3',
	restaurantAccountDetails: '1-3',
	systemSet: '4'
	}
@Component
export default class SlideMenu extends Vue {
	private menuActive: string = '0'
	@Watch('$route')
	private onRouteChange (): void {
		(this as any).setCurrentMenuActive()
	}
	private onMenuClick (item: string): void {
		this.$emit('on-menu-click', item)
	}
	private onReportFormClick (path: string): void {
		(this as any).$fxGoBlank(path, this.$router)
	}
	private setCurrentMenuActive (): void {
		(this as any).menuActive = routerMap[this.$route.name as string]
	}
	private created (): void {
		(this as any).setCurrentMenuActive()
	}
}
